<!-- login modal -->
<ion-header>
  <ion-toolbar color="primary">
    <ion-title>Přihlášení / Registrace</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-segment [(ngModel)]="activeTab" (ionChange)="segmentChanged($event)">
    <ion-segment-button value="login">
      <ion-label>Přihlášení</ion-label>
    </ion-segment-button>
    <ion-segment-button value="signup">
      <ion-label>Registrace</ion-label>
    </ion-segment-button>
  </ion-segment>

  <!-- Login Form -->
  <div *ngIf="activeTab === 'login'">
    <ion-grid>
      <ion-row>
        <ion-col>
          <form [formGroup]="loginForm" (ngSubmit)="login()">
            <ion-list>
              <ion-item>
                <ion-label position="floating"><strong>Email</strong></ion-label>
                <ion-input formControlName="email" type="email"></ion-input>
              </ion-item>

              <ion-item>
                <ion-label position="floating"><strong>Heslo</strong></ion-label>
                <ion-input formControlName="pass" type="password"></ion-input>
              </ion-item>
            </ion-list>
            <ion-button expand="block" type="submit" [disabled]="!loginForm.valid">Přihlásit</ion-button>
          </form>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          <ion-button expand="block" fill="clear" (click)="switchModeToPassReset()">
            Zapomněli jste heslo?
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>

  <!-- Signup Form -->
  <div *ngIf="activeTab === 'signup'">
    <ion-grid>
      <ion-row>
        <ion-col>
          <form [formGroup]="signupForm" (ngSubmit)="signup()">
            <ion-list>
              <ion-item>
                <ion-label position="floating"><strong>Email</strong></ion-label>
                <ion-input formControlName="email" type="email"></ion-input>
              </ion-item>

              <ion-item>
                <ion-label position="floating"><strong>Heslo</strong></ion-label>
                <ion-input formControlName="pass" type="password" minlength="6"></ion-input>
              </ion-item>
              <span class="sublabel">Alespoň 6 znaků</span>

              <ion-item>
                <ion-label position="floating"><strong>Přezdívka</strong></ion-label>
                <ion-input formControlName="name"></ion-input>
              </ion-item>
              <span class="sublabel">Bude veřejně viditelné</span>

              <ion-item>
                <ion-label position="floating"><strong>Jméno</strong></ion-label>
                <ion-input formControlName="firstName"></ion-input>
              </ion-item>
              <span class="sublabel">Nebude veřejně viditelné</span>

              <ion-item>
                <ion-label position="floating"><strong>Příjmení</strong></ion-label>
                <ion-input formControlName="lastName"></ion-input>
              </ion-item>
              <span class="sublabel">Nebude veřejně viditelné</span>
            </ion-list>
            <ion-button expand="block" type="submit" [disabled]="!signupForm.valid">Registrovat</ion-button>
          </form>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>

  <!-- Password Reset Form -->
  <div *ngIf="mode === 'passReset'">
    <ion-grid>
      <ion-row>
        <ion-col>
          <form [formGroup]="passResetForm" (ngSubmit)="resetPassword()">
            <ion-list>
              <ion-item>
                <ion-label position="floating"><strong>Email</strong></ion-label>
                <ion-input formControlName="email" type="email"></ion-input>
              </ion-item>
            </ion-list>
            <ion-button expand="block" type="submit" [disabled]="!passResetForm.valid">
              Obnovit heslo
            </ion-button>
            <ion-button expand="block" fill="clear" (click)="switchModeToLogin()">
              Zpět na přihlášení
            </ion-button>
          </form>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>
